import type React from "react";

export function colorizeJson(json: string): React.ReactNode[] {
  const nodes: React.ReactNode[] = [];
  // Captures: (1) key with colon+surrounding ws, (2) string value, (3) number,
  // (4) boolean, (5) null, (6) structural chars
  const regex =
    /("(?:\\.|[^"\\])*")(\s*:\s*)|("(?:\\.|[^"\\])*")|(-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)|(\btrue\b|\bfalse\b)|(\bnull\b)|([{}[\],])/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(json)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(json.slice(lastIndex, match.index));
    }
    if (match[1]) {
      // Key — preserve the exact colon + whitespace from the source
      nodes.push(
        <span key={match.index} className="text-sky-600 dark:text-sky-400">{match[1]}</span>,
      );
      nodes.push(match[2]);
    } else if (match[3]) {
      // String value
      nodes.push(
        <span key={match.index} className="text-emerald-600 dark:text-emerald-400">
          {match[3]}
        </span>,
      );
    } else if (match[4]) {
      // Number
      nodes.push(
        <span key={match.index} className="text-amber-600 dark:text-amber-400">{match[4]}</span>,
      );
    } else if (match[5]) {
      // Boolean
      nodes.push(
        <span key={match.index} className="text-violet-600 dark:text-violet-400">{match[5]}</span>,
      );
    } else if (match[6]) {
      // Null
      nodes.push(
        <span key={match.index} className="text-red-500 dark:text-red-400">{match[6]}</span>,
      );
    } else if (match[7]) {
      // Structural
      nodes.push(
        <span key={match.index} className="text-muted-foreground">{match[7]}</span>,
      );
    }
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < json.length) {
    nodes.push(json.slice(lastIndex));
  }
  return nodes;
}
